function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect } from "react";
import { Upload, Alert, Button, notification } from 'antd';
import { CheckCircleFilled } from '@ant-design/icons';
import ImgCrop from 'antd-img-crop';
import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import Common from "../includes/Common";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";

var EditUserAvatar = function EditUserAvatar(_ref) {
  var user = _ref.user;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isLogoAdded = _useState2[0],
      setIsLogoAdded = _useState2[1];

  var _useState3 = useState([{
    uid: '-1',
    name: 'image.png',
    status: 'done',
    url: Common.baseUrl + Common.currentUser.avatar
  }]),
      _useState4 = _slicedToArray(_useState3, 2),
      fileList = _useState4[0],
      setFileList = _useState4[1];

  var _useState5 = useState(1),
      _useState6 = _slicedToArray(_useState5, 2),
      uploadStatus = _useState6[0],
      setUploadStatus = _useState6[1];

  var _useState7 = useState(''),
      _useState8 = _slicedToArray(_useState7, 2),
      serverResponse = _useState8[0],
      setServerResponse = _useState8[1];

  var onChange = function onChange(_ref2) {
    var newFile = _ref2.file,
        newFileList = _ref2.fileList,
        e = _ref2.event;
    if (fileList.length > 1) return;
    setFileList(newFileList); //console.log(e.toString());  

    if (newFile.status === 'done') {
      setServerResponse(newFile.response.message);

      if (newFile.response.status == '200') {
        setIsLogoAdded(true);
      } else {
        setUploadStatus(0);
      }
    }
  };

  var onPreview = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(file) {
      var src, image, imgWindow;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            src = file.url;

            if (src) {
              _context.next = 5;
              break;
            }

            _context.next = 4;
            return new Promise(function (resolve) {
              var reader = new FileReader();
              reader.readAsDataURL(file.originFileObj);

              reader.onload = function () {
                return resolve(reader.result);
              };
            });

          case 4:
            src = _context.sent;

          case 5:
            image = new Image();
            image.src = src;
            imgWindow = window.open(src);
            imgWindow.document.write(image.outerHTML);

          case 9:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));

    return function onPreview(_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  var onRemove = function onRemove(file) {
    axios.get(Common.baseApiUrl + 'deleteuseravatar/' + user.id.toString()).then(function (response) {
      if (response.data.status == 200) {
        notification.success(_defineProperty({
          message: "Ok"
        }, "message", response.data.message));
      } else {
        notification.error(_defineProperty({
          message: "Oops!"
        }, "message", response.data.message));
        setFileList([file]);
      }
    })["catch"](function (error) {
      notification.error(_defineProperty({
        message: "Oops!"
      }, "message", "Une erreur est survenue"));
      setFileList([file]);
    });
  };

  useEffect(function () {}, []);
  return /*#__PURE__*/_jsxs("div", {
    style: {
      textAlign: 'center'
    },
    children: [/*#__PURE__*/_jsx(ImgCrop, {
      rotate: true,
      children: /*#__PURE__*/_jsx(Upload, {
        action: Common.baseApiUrl + 'setuseravatar/' + user.id.toString(),
        listType: "picture-card",
        fileList: fileList,
        name: "avatar",
        onChange: onChange,
        onPreview: onPreview,
        onRemove: onRemove,
        children: fileList.length < 1 && '+ Photo'
      })
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), isLogoAdded ? /*#__PURE__*/_jsx(Alert, {
      banner: true,
      closable: true,
      style: {
        marging: '5px 0px',
        fontSize: '14px'
      },
      message: serverResponse,
      type: "success",
      showIcon: true
    }) : /*#__PURE__*/_jsx("span", {}), uploadStatus == 0 ? /*#__PURE__*/_jsx(Alert, {
      banner: true,
      closable: true,
      style: {
        marging: '5px 0px',
        fontSize: '14px'
      },
      message: serverResponse,
      type: "error",
      showIcon: true
    }) : /*#__PURE__*/_jsx("span", {})]
  });
};

export default EditUserAvatar;